module.exports = __webpack_public_path__ + "img/loading-img.e839f70d.gif";